import { URGENCY_MESSAGE_GET_SUCCESS } from '../actionTypes/UrgencyMessagingActionTypes';

function UrgencyMessagingReducer(state = {}, action) {
    switch (action.type) {
        case URGENCY_MESSAGE_GET_SUCCESS:
            return action.urgencyStatements;
        default:
            return state;
    }
}

export default UrgencyMessagingReducer;
